<!-- Basis data -->
<div class="card">

  <div class="row" *ngIf="basisData">

    <div class="col-6">
      <div class="row photos" [ngClass]="{'no-photos': images.length == 0}" *ngIf="images.length == 0">
        <!-- <div class="col-3 side-photo block-no-photo">
          <img src="/assets/images/icons/no-photo.svg" alt="background image">
        </div> -->
        <div class="col-11 front-photo block-no-photo">
          <img src="/assets/images/icons/no-photo.svg" alt="background image">
        </div>
      </div>
      <div class="row photos" *ngIf="images.length > 0">
        <div class="col-3 side-photo">
          <img src="{{ image.content }}" *ngFor="let image of images; let i = index" alt="background image" (click)="swithMainImg(image)">
        </div>
        
        <div *ngIf="mainImage.content && gallaryImages" class="col-8 front-photo">

          <img src="{{ mainImage.content }}"  (click)="openModalViaService()">

          <div [ngClass]="{'gallertPerview': isGalleryOpen}">
            <ks-modal-gallery [attr.hidden]="isGalleryOpen === true ? null : 'true'" 
            (close)="isGalleryOpen=false;" [id]="0" [modalImages]="gallaryImages" [plainGalleryGrid]="plainGalleryGrid"></ks-modal-gallery>
          </div>

        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="second-line-of-attrs">
        <div class="product-info">
          <div class="product-info-title">{{ 'PRODUCT.PRODUCT_NAME_AND_IDENTIFICATION' | translate }}</div>

          <div class="product-info-sub-title">{{ 'PRODUCT.FULL_PRODUCT_NAME' | translate }}</div>
          <div class="product-info-value">{{ basisData.name }}</div>

          <div class="product-info-sub-title">{{ 'PRODUCT.VENDOR_CODE' | translate }}</div>
          <div class="product-info-value">{{ basisData.vendor_code }}</div>

          <div class="product-info-sub-title" *ngIf="addinfoData.length > 0">{{ getAttrName('15874081-7b3b-4fd5-84dd-1171b0307e23', '41a86cc3-8bf9-4bd5-9b31-34b6ad439b63') }}</div>
          <div class="product-info-value"     *ngIf="addinfoData.length > 0">{{ getAttrValue('15874081-7b3b-4fd5-84dd-1171b0307e23', '41a86cc3-8bf9-4bd5-9b31-34b6ad439b63') }}</div>
        </div>
        <div class="product-info">
          <div class="product-info-title">{{ 'PRODUCT.PRODUCT_BARCODES' | translate }}</div>
          <div class="product-info-value">
            <div class="barcode-box">
              <ngx-barcode [bc-value]="basisData.code" [bc-display-value]="true"></ngx-barcode>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- addInfo -->
<div class="card addinfo-card">
  <app-addinfo-profile (gettedDataEvent)="setProductData($event)"></app-addinfo-profile>
  <div class="btn-edit">
    <button type="button" class="btn btn-light btn-sm mr-2 btn-back"  onClick="history.back()">
      <!-- <i class="bi bi-arrow-left-square mr-2"></i> -->
      {{ 'BACK' | translate }}
    </button>
    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onEdit()"  *ngIf="permissionAccess.check('ADDINFO_EDIT')">
      <!-- <i class="bi bi-pencil-square"></i>  -->
      {{ 'EDIT' | translate }}
    </button>
  </div>
</div>